import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Performance from "@/pages/performance/page";
import HowItWorks from "@/pages/how-it-works/page";
import GetEa from "@/pages/get-ea/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "performance",
        element: <Performance />,
      },
      {
        path: "how-it-works",
        element: <HowItWorks />,
      },
      {
        path: "get-ea",
        element: <GetEa />,
      },
      {
        path: "faq",
        element: <Faq />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;